function clamp(value, min, max) {
  return Math.min(Math.max(value, min), max);
}

function updateZoomPosition(overlay, event, zoomRatio) {
  const bounds = overlay.getBoundingClientRect();
  const xPercent = clamp(((event.clientX - bounds.left) / bounds.width) * 100, 0, 100);
  const yPercent = clamp(((event.clientY - bounds.top) / bounds.height) * 100, 0, 100);

  // Percent units are essential here: unitless values pin the zoom to a few pixels from one edge.
  overlay.style.backgroundPosition = `${xPercent}% ${yPercent}%`;
  overlay.style.backgroundSize = `${zoomRatio * 100}% auto`;
}

function createOverlay(image, event, zoomRatio) {
  const overlay = document.createElement('div');
  overlay.className = 'image-magnify-full-size';
  overlay.setAttribute('aria-hidden', 'true');
  overlay.style.backgroundImage = `url('${image.currentSrc || image.src}')`;
  overlay.style.backgroundColor = 'var(--gradient-background)';
  overlay.style.backgroundRepeat = 'no-repeat';
  image.parentElement.insertBefore(overlay, image);
  image.parentElement.parentElement.querySelector('.zoom-icon')?.classList.add('zoom-icon-minus');
  updateZoomPosition(overlay, event, zoomRatio);

  overlay.addEventListener('mousemove', (moveEvent) => updateZoomPosition(overlay, moveEvent, zoomRatio));
  overlay.addEventListener('mouseleave', () => {
    overlay.remove();
    image.parentElement.parentElement.querySelector('.zoom-icon')?.classList.remove('zoom-icon-minus');
  }, { once: true });
}

function enableZoomOnHover(zoomRatio) {
  document.querySelectorAll('.image-magnify-hover').forEach((image) => {
    image.addEventListener('mouseenter', (event) => {
      if (!image.parentElement.querySelector('.image-magnify-full-size')) {
        createOverlay(image, event, zoomRatio);
      }
    });
  });
}

enableZoomOnHover(2);
